import { useMutation } from '@tanstack/react-query';

import { Entity } from '../../../../types/utility';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { postDocumentForm } from '../../requests/postDocumentForm';
import { DocumentParams } from '../../types/DocumentParams';

export const useUpdateDocumentForm = (documentParams: DocumentParams) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: updateDocumentForm, ...rest } = useMutation({
    mutationFn: ({
      documentId,
      data,
      formIdentifier,
      path,
    }: {
      documentId: string;
      data: Entity;
      formIdentifier: string;
      path?: string;
    }) =>
      postDocumentForm(
        constructPost,
        documentId,
        documentParams,
        data,
        formIdentifier,
        path,
      ),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Error saving document')),
  });

  return { updateDocumentForm, ...rest };
};
